module.exports = __webpack_public_path__ + "img/identification.e7e1f920.svg";